export const THANKS = 'thanks';
